import { useTranslation } from 'react-i18next'
import { Page } from '@/components/layout/Page'
import { PageHeading } from '@/components/layout/PageHeading'

export default function AnalyticsPage() {
  const { t } = useTranslation()
  return (
    <Page>
      <PageHeading eyebrow={t('analytics.eyebrow')} title={t('analytics.title')} />
    </Page>
  )
}
